"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.order = exports.orderTypes = void 0;
const Transformation_1 = require("../Transformation");
// Determine the relative numerical order of the two given terms.
function orderTypes(litA, litB, isAscending) {
    if (litA && litA.termType === 'Literal' && litB && litB.termType === 'Literal') {
        const myLitA = (0, Transformation_1.transformLiteral)(litA);
        const myLitB = (0, Transformation_1.transformLiteral)(litB);
        return order(myLitA, myLitB, isAscending);
    }
    return 0;
}
exports.orderTypes = orderTypes;
// Effective ordering
function order(orderA, orderB, isAscending) {
    if (orderA.typedValue === orderB.typedValue) {
        return 0;
    }
    return orderA.typedValue > orderB.typedValue === isAscending ? 1 : -1;
}
exports.order = order;
//# sourceMappingURL=Ordering.js.map